(function () {
  var MAX_WAIT = 15000;
  var POLL_MS = 500;

  function waitForKlaviyo(callback) {
    var start = Date.now();
    (function poll() {
      var w = document.getElementById('klaviyo-product-reviews-wrapper');
      if (w) {
        var hasReviews = w.querySelectorAll('.kl_reviews__review_item').length > 0;
        callback(w, hasReviews);
        return;
      }
      if (Date.now() - start < MAX_WAIT) setTimeout(poll, POLL_MS);
    })();
  }

  function measureHeader() {
    var header = document.querySelector('header, .header, .shopify-section-header, #shopify-section-header');
    if (header) {
      document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
    }
  }

  function buildLayout(wrapper, hasReviews) {
    if (wrapper._reviewsCleanup) wrapper._reviewsCleanup();

    var items = Array.from(wrapper.querySelectorAll('.kl_reviews__review_item'));
    var total = items.length;

    if (!hasReviews || total === 0) return;

    var histogram = wrapper.querySelector(
      '[class*="histogram"], [class*="breakdown"], [class*="rating_bar"]'
    );
    if (!histogram) return;

    var summary = null;
    var el = histogram;
    while (el.parentElement && el.parentElement !== wrapper) el = el.parentElement;
    summary = el;

    var headingEl = wrapper.querySelector('h2');
    var headingText = headingEl ? headingEl.textContent : 'Customer reviews';

    var totalReviewCount = 0;
    var countSources = [
      wrapper.querySelector('[class*="stars__count"]'),
      wrapper.querySelector('[class*="list__tab--active"]'),
      wrapper.querySelector('[class*="list__tab"]'),
      wrapper.querySelector('[class*="kl_reviews__tab"]')
    ];
    for (var ci = 0; ci < countSources.length; ci++) {
      if (countSources[ci]) {
        var match = countSources[ci].textContent.match(/(\d+)/);
        if (match && parseInt(match[1], 10) > total) {
          totalReviewCount = parseInt(match[1], 10);
          break;
        }
      }
    }
    if (!totalReviewCount) totalReviewCount = total;

    var writeEl = wrapper.querySelector(
      'a[href*="write"], [class*="write_review"] a, [class*="write_review"] button, button[class*="write"], .kl_reviews__button_bar button, button.kl_reviews__button'
    );

    var loadMoreWrap = wrapper.querySelector('.kl_reviews__load_more_button') ||
                       wrapper.querySelector('[class*="load_more"]');
    var loadMoreBtn = loadMoreWrap ? loadMoreWrap.querySelector('button') : null;

    var itemParent = items[0].parentElement;

    wrapper.style.visibility = 'hidden';

    var heading = document.createElement('h2');
    heading.className = 'reviews-section-heading';
    heading.textContent = headingText;

    var grid = document.createElement('div');
    grid.className = 'reviews-grid';

    var sidebar = document.createElement('div');
    sidebar.className = 'reviews-sidebar';
    if (summary) sidebar.appendChild(summary);

    if (writeEl) {
      var wBtn = document.createElement('button');
      wBtn.className = 'reviews-write-btn';
      wBtn.textContent = 'Write a review';
      var originalWriteEl = writeEl;
      wBtn.addEventListener('click', function () {
        if (originalWriteEl.href) {
          window.open(originalWriteEl.href, '_blank');
        } else {
          originalWriteEl.click();
        }
      });
      sidebar.appendChild(wBtn);
    }

    var carouselWrap = document.createElement('div');
    carouselWrap.className = 'reviews-carousel-wrap';

    var track = document.createElement('div');
    track.className = 'reviews-carousel-track';
    track.setAttribute('role', 'region');
    track.setAttribute('aria-roledescription', 'carousel');
    track.setAttribute('aria-label', 'Customer reviews');
    track.setAttribute('tabindex', '0');

    if (total === 1) track.classList.add('reviews-carousel-track--single');

    var frag = document.createDocumentFragment();
    items.forEach(function (item) {
      item.setAttribute('role', 'group');
      item.setAttribute('aria-roledescription', 'slide');
      frag.appendChild(item);
    });
    track.appendChild(frag);

    var endSpacer = document.createElement('div');
    endSpacer.className = 'reviews-end-spacer';
    track.appendChild(endSpacer);

    var prevDot = document.createElement('button');
    prevDot.className = 'reviews-nav-dot';
    prevDot.setAttribute('aria-label', 'Previous reviews');

    var nextDot = document.createElement('button');
    nextDot.className = 'reviews-nav-dot';
    nextDot.setAttribute('aria-label', 'Next reviews');

    var showMoreContainer = document.createElement('div');
    showMoreContainer.className = 'reviews-show-more';
    var ourShowMore = null;

    if (loadMoreBtn && total < totalReviewCount) {
      ourShowMore = document.createElement('button');
      ourShowMore.className = 'reviews-show-more-btn';
      ourShowMore.textContent = 'Show more';
      ourShowMore.addEventListener('click', function () {
        loadMoreBtn.click();
        ourShowMore.textContent = 'Loading...';
        ourShowMore.disabled = true;
      });
      showMoreContainer.appendChild(ourShowMore);
    }

    var dotsContainer = document.createElement('div');
    dotsContainer.className = 'reviews-nav-dots';
    dotsContainer.appendChild(prevDot);
    dotsContainer.appendChild(nextDot);

    var bottomRow = document.createElement('div');
    bottomRow.className = 'reviews-bottom-row';
    bottomRow.appendChild(dotsContainer);
    bottomRow.appendChild(showMoreContainer);

    var mobileWriteBtn = null;
    if (writeEl) {
      mobileWriteBtn = document.createElement('button');
      mobileWriteBtn.className = 'reviews-write-btn reviews-write-btn--mobile';
      mobileWriteBtn.textContent = 'Write a review';
      mobileWriteBtn.addEventListener('click', function () {
        if (originalWriteEl.href) {
          window.open(originalWriteEl.href, '_blank');
        } else {
          originalWriteEl.click();
        }
      });
    }

    carouselWrap.appendChild(track);
    carouselWrap.appendChild(bottomRow);
    if (mobileWriteBtn) carouselWrap.appendChild(mobileWriteBtn);

    grid.appendChild(sidebar);
    grid.appendChild(carouselWrap);

    Array.from(wrapper.children).forEach(function (child) {
      child.style.display = 'none';
    });

    wrapper.appendChild(heading);
    wrapper.appendChild(grid);
    wrapper.classList.add('reviews-carousel-active');
    wrapper.style.visibility = '';

    if (total <= 1) {
      bottomRow.style.display = 'none';
    }

    var cachedCardWidth = null;

    function cardWidth() {
      if (cachedCardWidth !== null) return cachedCardWidth;
      var card = track.querySelector('.kl_reviews__review_item');
      if (!card) return 300;
      var gap = parseFloat(getComputedStyle(track).gap) || 16;
      cachedCardWidth = card.offsetWidth + gap;
      return cachedCardWidth;
    }

    function sizeEndSpacer() {
      var card = track.querySelector('.kl_reviews__review_item');
      if (!card || total <= 2) { endSpacer.style.flexBasis = '0'; return; }
      var gap = parseFloat(getComputedStyle(track).gap) || 16;
      var rPad = parseFloat(getComputedStyle(track).paddingRight) || 4;
      var w = track.clientWidth - 2 * card.offsetWidth - 2 * gap - rPad;
      endSpacer.style.flexBasis = Math.max(w, 0) + 'px';
    }

    function updateNav() {
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      prevDot.disabled = atStart;
      nextDot.disabled = atEnd;

      if (atEnd && showMoreContainer.querySelector('.reviews-show-more-btn')) {
        showMoreContainer.classList.add('reviews-show-more--visible');
      } else {
        showMoreContainer.classList.remove('reviews-show-more--visible');
      }
    }

    function onPrev() {
      track.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
    }
    function onNext() {
      track.scrollBy({ left: cardWidth(), behavior: 'smooth' });
    }

    var scrollTimer;
    function onScroll() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateNav, 60);
    }

    function positionDots() {
      var card = track.querySelector('.kl_reviews__review_item');
      if (card && track.querySelectorAll('.kl_reviews__review_item').length >= 2 && window.innerWidth > 749) {
        var padLeft = parseFloat(getComputedStyle(track).paddingLeft) || 4;
        var gap = parseFloat(getComputedStyle(track).gap) || 16;
        dotsContainer.style.left = (padLeft + card.offsetWidth + gap / 2) + 'px';
      } else {
        dotsContainer.style.left = '';
      }
    }

    function onResize() {
      cachedCardWidth = null;
      sizeEndSpacer();
      positionDots();
      updateNav();
    }

    prevDot.addEventListener('click', onPrev);
    nextDot.addEventListener('click', onNext);
    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);

    function openReviewModal(card) {
      var overlay = document.createElement('div');
      overlay.className = 'reviews-modal-overlay';
      var modal = document.createElement('div');
      modal.className = 'reviews-modal';

      var closeBtn = document.createElement('button');
      closeBtn.className = 'reviews-modal-close';
      closeBtn.setAttribute('aria-label', 'Close review');
      closeBtn.textContent = '×';

      var content = card.cloneNode(true);
      content.style.cssText = 'flex:none;height:auto;overflow:visible;border:none;padding:0;margin:0;cursor:default;background:none;box-shadow:none';

      modal.appendChild(closeBtn);
      modal.appendChild(content);
      overlay.appendChild(modal);
      document.body.appendChild(overlay);

      requestAnimationFrame(function () {
        overlay.classList.add('reviews-modal-overlay--visible');
      });

      function close() {
        overlay.classList.remove('reviews-modal-overlay--visible');
        setTimeout(function () { overlay.remove(); }, 200);
      }

      closeBtn.addEventListener('click', close);
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) close();
      });
      document.addEventListener('keydown', function handler(e) {
        if (e.key === 'Escape') { close(); document.removeEventListener('keydown', handler); }
      });
    }

    track.addEventListener('click', function (e) {
      var card = e.target.closest('.kl_reviews__review_item');
      if (card && track.contains(card)) openReviewModal(card);
    });

    sizeEndSpacer();
    positionDots();
    updateNav();

    var itemObserver = new MutationObserver(function (mutations) {
      var newItems = [];
      mutations.forEach(function (m) {
        for (var i = 0; i < m.addedNodes.length; i++) {
          var node = m.addedNodes[i];
          if (node.nodeType === 1 && node.classList && node.classList.contains('kl_reviews__review_item')) {
            newItems.push(node);
          }
        }
      });
      if (newItems.length > 0) {
        var f = document.createDocumentFragment();
        newItems.forEach(function (item) {
          item.setAttribute('role', 'group');
          item.setAttribute('aria-roledescription', 'slide');
          f.appendChild(item);
        });
        var savedScroll = track.scrollLeft;
        track.insertBefore(f, endSpacer);
        track.scrollLeft = savedScroll;
        cachedCardWidth = null;
        if (ourShowMore) {
          ourShowMore.textContent = 'Show more';
          ourShowMore.disabled = false;
          showMoreContainer.classList.remove('reviews-show-more--visible');
        }
        var nowLoaded = track.querySelectorAll('.kl_reviews__review_item').length;
        if (nowLoaded >= totalReviewCount) {
          showMoreContainer.style.display = 'none';
        }
        updateNav();
      }
    });
    itemObserver.observe(itemParent, { childList: true, subtree: true });

    var wrapperObserver = new MutationObserver(function () {
      if (!wrapper.querySelector('.reviews-grid')) {
        wrapperObserver.disconnect();
        itemObserver.disconnect();
        window.removeEventListener('resize', onResize);
        startCarousel(wrapper);
      }
    });
    wrapperObserver.observe(wrapper, { childList: true });

    wrapper._reviewsCleanup = function () {
      track.removeEventListener('scroll', onScroll);
      prevDot.removeEventListener('click', onPrev);
      nextDot.removeEventListener('click', onNext);
      window.removeEventListener('resize', onResize);
      itemObserver.disconnect();
      wrapperObserver.disconnect();
    };
  }

  function startCarousel(wrapper) {
    var hasReviews = wrapper.querySelectorAll('.kl_reviews__review_item').length > 0;
    buildLayout(wrapper, hasReviews);
  }

  waitForKlaviyo(function (wrapper, hasReviews) {
    if (hasReviews) {
      buildLayout(wrapper, true);
    }
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('#klaviyo-product-reviews-wrapper')) {
      waitForKlaviyo(function (wrapper) {
        startCarousel(wrapper);
      });
    }
  });
})();
